export default __webpack_public_path__ + "static/media/logo-khaihoanprime.e0192211.png";